import {type ReactNode} from 'react'
// Styles
import styles from './modal-container.module.scss'

interface ModalContainerProps {
  children: ReactNode
  modalTitle?: string
  modalHasCloseButton?: boolean
  onUpdateModal: (value: null) => void
}

const ModalContainer = ({
  children,
  modalTitle,
  modalHasCloseButton,
  onUpdateModal,
}: ModalContainerProps) => {
  const isShowingHeader = modalTitle || modalHasCloseButton
  return (
    <div className={styles['modal-container']}>
      <div className={styles['modal']}>
        {isShowingHeader &&
          <div className={styles['__header']}>
            {modalTitle && <div className={styles['__title']}>{modalTitle}</div>}
            {modalHasCloseButton &&
              <div className={styles['__button-group']}>
                <button
                  className={`button is-rounded ${styles['__close-button']}`}
                  onClick={() => onUpdateModal(null)}
                >
                  ✖
                </button>
              </div>
            }
          </div>
        }
        <div className={styles['__content']}>
          {children}
        </div>
      </div>
      <button
        className={styles['__overlay']}
        onClick={() => onUpdateModal(null)}
      ></button>
    </div>
  )
}

export default ModalContainer
